<app-title [title]="title$ | async | translate"></app-title>
<ng-content></ng-content>
